import { render, staticRenderFns } from "./EquityEditor.vue?vue&type=template&id=bcc0cf36&"
import script from "./EquityEditor.vue?vue&type=script&lang=ts&"
export * from "./EquityEditor.vue?vue&type=script&lang=ts&"
import style0 from "./EquityEditor.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports